// extracted by mini-css-extract-plugin
export var accordionButtons = "burger-menu-module--accordionButtons--66ad1";
export var burgerMenuIcon = "burger-menu-module--burgerMenuIcon--06710";
export var closed = "burger-menu-module--closed--ac502";
export var languageSelector = "burger-menu-module--languageSelector--02522";
export var menus = "burger-menu-module--menus--4c6b4";
export var opened = "burger-menu-module--opened--65b1a";